import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faSave, faPrint } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import { navigate } from 'hookrouter';
import BusinessDetailsPreview from '../preview/BusinessDetailsPreview';
import OwnerDetailsPreview from '../preview/OwnerDetailsPreview';
import FinancialsPreview from '../preview/FinancialsPreview';
import Declaration from '../preview/Declaration';
import { Alert } from '../../components/Config';
import TourismDeclare from '../preview/TourismDeclare';
import logo from '../../assets/logo.png';
import PrintJob from 'print-job';

function Confirmation(props){
    const [registration, setRegistration] = useState(props.registration);
    const [businessDetails, setBusinessDetails] = useState(props.businessDetails);
    const [ownerDetails, setOwnerDetails] = useState(props.ownerDetails);
    const [financials, setFinancials] = useState(props.financials);

    const [branches, setBranches] = useState(props.branches);
    const [shareholdings, setShareholdings] = useState(props.shareholdings);
    const [performance, setPerformance] = useState(props.performance);
    const [covidImpactDetails, setCovidImpactDetails] = useState(props.covidImpactDetails);
    const [expenditures, setExpenditures] = useState(props.expenditures);
    const [expectedResults, setExpectedResults] = useState(props.expectedResults);
    const [techAssistance, setTechAssistance] = useState(props.techAssistance);
    const [heardAbouts, setHeardAbouts] = useState(props.heardAbouts);
    const [dropdowns, setDropdowns] = useState(props.dropdowns);
    const [techOther, setTechOther] = useState(props.techOther);
    const [apptype, setApptype] = useState(props.apptype);

    const componentRef = useRef();
    
    useEffect(() => {
        props.getProps(props);
        setRegistration(props.registration);
        setDropdowns(props.dropdowns);
        setBusinessDetails(props.businessDetails);
        setOwnerDetails(props.ownerDetails);
        setFinancials(props.financials);
        setBranches(props.branches);
        setShareholdings(props.shareholdings);
        setPerformance(props.performance);
        setCovidImpactDetails(props.covidImpactDetails);
        setExpenditures(props.expenditures);
        setExpectedResults(props.expectedResults);
        setTechAssistance(props.techAssistance);
        setHeardAbouts(props.heardAbouts);
        setTechOther(props.techOther);
        setApptype(apptype);
    },[performance]);

    const handleClick = (e,val) => {
        $('#myTab li a').removeClass('active');
        $('#myTabContent div').removeClass('show');
        $('#myTabContent div').removeClass('active');

        $(e.target).addClass('active');

        $('div#' + $(e.target).attr('aria-controls')).addClass('show');
        $('div#' + $(e.target).attr('aria-controls')).addClass('active');
    }

    const saveReturn = () => {
        
        Alert({title:'Save and Return',message:'Stage 2: Application saved success...', buttons:[{label:'Ok'}]});

        navigate('/introduction',true);
        window.location.reload();
    }

    const editForm = (pos) => {
        props.handleClick(pos);
    }

    const handlePrint = () => {
        PrintJob.print('#printCon');
    }

    return(
        <div className="content">
            <h5>Confirm &amp; Complete <span>Application</span></h5><br />
            <div>
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" onClick={(e)=>handleClick(e,0)}>
                        <a className="nav-link active" role="tab" aria-controls="bus-tab" aria-selected="true">Business Details</a>
                    </li>
                    <li className="nav-item"  onClick={(e)=>handleClick(e,1)}>
                        <a className="nav-link" data-toggle="tab" role="tab" aria-controls="own-tab" aria-selected="false">Owner Details</a>
                    </li>
                    <li className="nav-item"  onClick={(e)=>handleClick(e,2)}>
                        <a className="nav-link" data-toggle="tab" role="tab" aria-controls="fin-tab" aria-selected="false">Financial Details</a>
                    </li>
                    <li className="nav-item"  onClick={(e)=>handleClick(e,3)}>
                        <a className="nav-link" data-toggle="tab" role="tab" aria-controls="declare-tab" aria-selected="false">Declaration</a>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent" style={{overflow:'hidden'}}>
                    <div className="tab-pane fade show active p-3" id="bus-tab" role="tabpanel" aria-labelledby="tab">
                        <BusinessDetailsPreview businessDetails={businessDetails} editForm={editForm} branches={branches} shareholdings={shareholdings} performance={performance} covidImpactDetails={covidImpactDetails} dropdowns={dropdowns} registration={registration} />
                    </div>
                    <div className="tab-pane fade p-3" id="own-tab" role="tabpanel" aria-labelledby="tab">
                        <OwnerDetailsPreview ownerDetails={ownerDetails} editForm={editForm} dropdowns={dropdowns} registration={registration} />
                    </div>
                    <div className="tab-pane fade p-3" id="fin-tab" role="tabpanel" aria-labelledby="tab">
                        <FinancialsPreview financials={financials} editForm={editForm} techOther={techOther} expenditures={expenditures} expectedResults={performance} businessDetails={businessDetails} techAssistance={techAssistance} heardAbouts={heardAbouts} dropdowns={dropdowns} registration={registration} />
                    </div>
                    <div className="tab-pane fade p-3" id="declare-tab" role="tabpanel" aria-labelledby="tab">
                      
                        <Declaration ownerDetails={ownerDetails} expenditures={expenditures} businessDetails={businessDetails} registration={registration} financials={financials} performance={performance} shareholdings={shareholdings} handleChange={props.handleChange} />
                        {/* {registration.tourism &&
                        <TourismDeclare financials={financials} handleChange={props.handleChange} registration={registration} apptype={apptype} />} */}

                        <button className="btn btn-bg btn-outline text-white pl-3 pr-3 pt-2 pb-2 mt-3" style={{borderRadius: '20px'}} onClick={() => props.doNavigate(props,7,0)}><FontAwesomeIcon icon={faCaretLeft} size="lg" /> &nbsp; Go Back </button>
                        <button className="btn btn-bg btn-outline text-white pl-3 pr-3 pt-2 pb-2 mt-3 ml-4" style={{borderRadius: '20px'}} onClick={saveReturn}><FontAwesomeIcon icon={faSave} size="lg" /> &nbsp; Save &amp; Return </button>
                        <button className="btn btn-bg btn-outline text-white pl-3 pr-3 pt-2 pb-2 mt-3 ml-4" style={{borderRadius: '20px'}} onClick={handlePrint}><FontAwesomeIcon icon={faPrint} size="lg" /> &nbsp; Print </button>
                    </div>
                    <div id="printCon" style={{height:'0px',position:'fixed',top:'1000000000000000px'}} >
                        <div className="row">
                            <div className="col-3"><img src={logo} className="img_logo mt-2" style={{height:'120px',width:'120px'}} /></div>
                            <div className="col-9 text-center" style={{color:'#4368ff'}}><br /><br />
                                <h3>SME High Growth Application Forms</h3>
                                <h3>Application Forms</h3>
                            </div>
                        </div>
                        <hr /><h5>Business <span>Details</span></h5>
                        <BusinessDetailsPreview businessDetails={businessDetails} editForm={editForm} branches={branches} shareholdings={shareholdings} performance={performance} covidImpactDetails={covidImpactDetails} dropdowns={dropdowns} registration={registration} apptype={apptype} />
                        <><hr /><h5>Owner <span>Details</span></h5>
                        <OwnerDetailsPreview ownerDetails={ownerDetails} editForm={editForm} dropdowns={dropdowns} registration={registration} /></>
                        <> <hr /><h5>Financial <span>Details</span></h5>
                        <FinancialsPreview financials={financials} editForm={editForm} techOther={techOther} expenditures={expenditures} expectedResults={performance} businessDetails={businessDetails} techAssistance={techAssistance} heardAbouts={heardAbouts} dropdowns={dropdowns} registration={registration} apptype={apptype} /></>
                        <hr /><h5>Declaration</h5>
                        <Declaration ownerDetails={ownerDetails} expenditures={expenditures} businessDetails={businessDetails} registration={registration} financials={financials} performance={performance} shareholdings={shareholdings} handleChange={props.handleChange}  />
                        {/* {registration.tourism &&
                        <TourismDeclare financials={financials} handleChange={props.handleChange} registration={registration} apptype={apptype} />} */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Confirmation;